// extracted by mini-css-extract-plugin
module.exports = {"c":"block-c_c__20X2u","c2":"block-c_c2__2lG5b"};